(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-landfill-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function esc(s) {
      return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function nl2br(s) { return esc(s).replace(/\n/g, '<br>'); }
    var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

    function validate(root) {
      var ok = true, first = null;
      root.querySelectorAll('[data-lff-field]').forEach(function (f) {
        var required = f.getAttribute('data-required') === 'true';
        var value = (f.value || '').trim();
        f.classList.remove('bb-lff__input--error');
        var bad = false;
        if (required && !value) bad = true;
        if (f.getAttribute('data-type') === 'email' && value && !EMAIL_RE.test(value)) bad = true;
        if (bad) { ok = false; f.classList.add('bb-lff__input--error'); if (!first) first = f; }
      });
      if (first) first.focus();
      return ok;
    }

    function buildHtml(root) {
      var logo = root.getAttribute('data-logo') || '';
      var title = root.getAttribute('data-print-title') || 'Landfill Free Program';
      var introEl = root.querySelector('[data-print-intro]');
      var intro = introEl ? introEl.innerHTML : '';
      var addrEl = root.querySelector('[data-lff-address]');
      var addr = addrEl ? addrEl.innerHTML : '';

      var rows = '';
      root.querySelectorAll('[data-lff-field]').forEach(function (f) {
        var label = f.getAttribute('data-label') || '';
        var value = (f.value || '').trim();
        if (f.getAttribute('data-type') === 'textarea') {
          rows += '<div class="q"><div class="ql">' + esc(label) + '</div><div class="qa">' + (value ? nl2br(value) : '&nbsp;') + '</div></div>';
        } else {
          rows += '<div class="f"><span class="fl">' + esc(label) + ':</span> <span class="fv">' + (value ? esc(value) : '&nbsp;') + '</span></div>';
        }
      });

      var css = '@page{size:letter;margin:0.7in;}'
        + '*{box-sizing:border-box;}'
        + 'body{font-family:Georgia,"Times New Roman",serif;color:#222;margin:0;line-height:1.5;}'
        + '.logo{display:block;margin:0 auto 12px;max-height:140px;width:auto;}'
        + 'h1{text-align:center;font-size:20px;letter-spacing:0.12em;text-transform:uppercase;color:#234C1D;margin:0 0 20px;}'
        + '.intro{font-size:12.5px;color:#333;margin:0 0 24px;}'
        + '.intro p{margin:0 0 10px;}'
        + '.f{font-size:14px;margin:0 0 16px;border-bottom:1px solid #999;padding-bottom:7px;}'
        + '.fl{font-weight:bold;}'
        + '.q{margin:0 0 18px;}'
        + '.ql{font-size:14px;font-weight:bold;margin:0 0 7px;color:#234C1D;}'
        + '.qa{font-size:13.5px;min-height:52px;border:1px solid #ccc;border-radius:6px;padding:9px 11px;white-space:pre-wrap;}'
        + '.addr{margin-top:30px;text-align:center;font-size:12.5px;font-weight:bold;color:#234C1D;line-height:1.6;}';

      return '<!doctype html><html><head><meta charset="utf-8"><title>' + esc(title) + '</title><style>' + css + '</style></head><body>'
        + (logo ? '<img class="logo" src="' + esc(logo) + '" alt="Bee Bella">' : '')
        + '<h1>' + esc(title) + '</h1>'
        + (intro ? '<div class="intro">' + intro + '</div>' : '')
        + rows
        + (addr ? '<div class="addr">Send your completed form with three empty lip balm tubes to:<br>' + addr + '</div>' : '')
        + '<scr' + 'ipt>window.addEventListener("load",function(){setTimeout(function(){window.focus();window.print();},300);});</scr' + 'ipt>'
        + '</body></html>';
    }

    function openPrint(root) {
      if (!validate(root)) return;
      var win = window.open('', '_blank');
      if (!win) { window.alert('Please allow pop-ups for this site so we can open your printable form.'); return; }
      win.document.open();
      win.document.write(buildHtml(root));
      win.document.close();
    }

    function init(root) {
      if (root.__bbLffInit) return;
      root.__bbLffInit = true;
      var btn = root.querySelector('[data-lff-print]');
      if (btn) btn.addEventListener('click', function () { openPrint(root); });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bb-lff]').forEach(init);
    }

    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
